/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import axiosConfig from './axiosConfig'
import { Link, withRouter, Redirect } from 'react-router-dom'
import { filterAndCleanCategories } from './utils/categoryUtils'
import { roundToDecimal } from './utils/mathUtils'


import { connect } from 'react-redux'
import { incrementCart, decrementCart, addToWishlist, removeFromWishlist } from './actions'
import WishListButton from './components/WishListButton'
import Spinner from './Spinner'
import { getImagesArr, getMainImage, getParsedDiscription } from './helper_funcitons'

class QuickViewModal extends Component {

    constructor(props) {
        super(props)

        let appState = localStorage.getItem('appState')
        if (appState) {
            appState = JSON.parse(localStorage.getItem('appState'))
        }

        this.slider_ref = React.createRef();

        this.state = {
            isLoggedIn: appState ? appState.isLoggedIn : false,

            // modal
            position: "fixed",
            display: "",
            // show_spinner: true,
            app_site_url: process.env.REACT_APP_APP_SITE,
            app_site_storage_path: process.env.REACT_APP_APP_SITE_STORAGE_PATH,
            sku: "",
            name: "",
            description: "",
            price: "",
            product_quantity: "",
            color: [],
            category_name: "",
            quantity: 1, // quantity to be added to cart
            image: "",
            product_data: {},

            redirect_to_login: false,

            product_images: []
        }
        this.closeModal = this.closeModal.bind(this)
        this.changeQuantity = this.changeQuantity.bind(this)
        this.addToCart = this.addToCart.bind(this)
        this.handleColorVariantSelection = this.handleColorVariantSelection.bind(this)
        this.product_images = [];
    }
    
    resetJqueries() {
        // Remove existing slider init script if it exists
        const existingScript = document.getElementById("quickview_slider_script");
        if (existingScript) {
            existingScript.remove();
        }
    
        // Create and append a new script to reinitialize the slider
        const script = document.createElement('script');
        script.id = "quickview_slider_script";
        script.text = `
            jQuery(document).ready(function() {
                if (jQuery('.js-product-main-carousel-qw').length && !jQuery('.js-product-main-carousel-qw').hasClass('slick-initialized')) {
                    jQuery('.js-product-main-carousel-qw').slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        fade: true,
                        asNavFor: '.js-product-previews-carousel-qw'
                    });
                }
    
                if (jQuery('.js-product-previews-carousel-qw').length && !jQuery('.js-product-previews-carousel-qw').hasClass('slick-initialized')) {
                    jQuery('.js-product-previews-carousel-qw').slick({
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        asNavFor: '.js-product-main-carousel-qw',
                        focusOnSelect: true,
                        arrows: true,
                        responsive: [
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 3
                                }
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    slidesToShow: 2
                                }
                            }
                        ]
                    });
                }
            });
        `;
        document.body.appendChild(script);
    }

    async handleColorVariantSelection(e, color) {
        e.preventDefault();
        const colorName = color?.name.toLowerCase();
      
        if (this.product_images && this.product_images.length > 0) {
          // Find the first image of selected color in the existing list
          const selectedImageIndex = this.product_images.findIndex(img =>
            img.attribute && img.attribute.toLowerCase() === colorName
          );
      
          if (selectedImageIndex !== -1) {
            setTimeout(() => {
              if (window.jQuery && window.jQuery('.js-product-main-carousel-qw').length) {
                window.jQuery('.js-product-main-carousel-qw').slick('slickGoTo', selectedImageIndex);
              } else if (document.querySelector('.js-product-main-carousel-qw')) {
                this.resetJqueries();
              }
            }, 100);
          }
        }

        if (this.props.updateSelectedColor) {
          this.props.updateSelectedColor(colorName);
        }

        this.setState({ selectedColor: color });
    }

    async componentDidMount() {
        this.getProductData();

        let { 
          name,
          description,
          short_description,
          price,
          // image,
          sku,
          total_qty,
          color,
          category_name } = this.props.product_data

        // let main_image = getMainImage(image)
        await this.setState({
            product_data: this.props.product_data,
            product_quantity: total_qty,
            sku,
            name,
            description: getParsedDiscription(description),
            short_description: getParsedDiscription(short_description),
            price,
            color: color ? JSON.parse(color) : [],
            selectedColor: color && JSON.parse(color).length > 0 ? JSON.parse(color)[0] : null,
            category_name: category_name ? category_name : "",
            // image: main_image
        })
    }
    async componentDidUpdate(prevProps) {
        if ((this.props.product_id !== prevProps.product_id || (this.props.show_modal && !prevProps.show_modal)) && this.props.product_id) {
            this.setState({
                show_spinner: true,
                quantity: 1,
                selectedColor: null
            }, () => {
                this.getProductData();
            });
        }
    }
    changeQuantity = (type) => {
        if (type === 'add') {
            this.setState((prev) => ({
                quantity: parseInt(prev.quantity) + 1
            }))
        } else {
            if (this.state.quantity !== 1) {

                this.setState((prev) => ({
                    quantity: parseInt(prev.quantity) - 1
                }))
            }
        }
    }


    addToCart = (el) => {
        let obj = {
            id: el.id,
            name: el.name,
            price: el.price,
            color: this.state.selectedColor?.name?.toLowerCase() || '',
            color_hex: this.state.selectedColor?.hex_value || '',
            color_id: this.state.selectedColor?.id,
            quantity: this.state.quantity,
            image: getMainImage(el.image),
            user_email: localStorage.getItem('user_email') || ''
        }
        this.props.incrementCart(obj);
        
        if (window.THEME && window.THEME.checkOutModal) {
            let p_data = {
                name: el.name,
                path: `${this.state.app_site_storage_path}${getMainImage(el.image)}`,
                url: `/product?id=${el.id}`,
                aspect_ratio: 0.778
            };
            window.THEME.checkOutModal.setData(p_data);
            window.THEME.checkOutModal.open();
        }

        this.closeModal(null, true);

        this.setState({
            quantity: 1,
        })
    }

    getProductData() {
        axiosConfig.get("/api/product/edit/" + this.props.product_id)
            .then(async (res) => {

                if (res.data.success) {
                    let { name, description, short_description, price, image, sku, total_qty, color, category_name, availability, retail_price, retail_price_discount } = res.data.data;

                    let originalPrice = retail_price ? parseFloat(retail_price) : 0;
                    let discountPercent = retail_price_discount ? parseFloat(retail_price_discount) : 0;
                    let hasDiscount = false;
                    let finalPrice = 0;

                    if (originalPrice > 0) {
                        if (discountPercent > 0) {
                            hasDiscount = true;
                            finalPrice = roundToDecimal(originalPrice - (originalPrice * discountPercent / 100));
                        } else {
                            finalPrice = roundToDecimal(originalPrice);
                            discountPercent = 0;
                        }
                    } else {
                        finalPrice = price ? roundToDecimal(price) : "0.00";
                        discountPercent = 0;
                    }
                    res.data.data.price = finalPrice;

                    res.data.data.price = finalPrice;

                    // let main_image = getMainImage(image)

                    await this.setState({
                        product_data: res.data.data,
                        product_quantity: total_qty,
                        availability,
                        sku,
                        name,
                        description: getParsedDiscription(description),
                        short_description: getParsedDiscription(short_description),
                        price: finalPrice,
                        retail_price: originalPrice,
                        retail_price_discount: discountPercent,
                        hasDiscount,
                        color: color ? JSON.parse(color) : [],
                        selectedColor: color && JSON.parse(color).length > 0 ? JSON.parse(color)[0] : null,
                        category_name: category_name ? (filterAndCleanCategories([{ name: category_name }])[0]?.name || category_name) : "",
                        // image: main_image
                    },
                    async () => {
    
    
                        let temp = getImagesArr(image)
        
        
                        //  show main first
                        let main_images = temp.filter(el => el.main === true);
                        let not_main_images = temp.filter(el => el.main !== true);
        
                        let all = [...main_images, ...not_main_images]
                        await this.setState({
                            product_images: all
        
                        }, () => {
                            this.product_images = all;
                            // this.removeSlick();
                            setTimeout(() => {
                                this.resetJqueries()
                            }, 500)
                        })
        
                        await this.setState({
                            image: getMainImage(image)
        
                        })
        
                        setTimeout(() => {
                            if (document.querySelector('.js-product-main-carousel-qw') && document.querySelector('.js-product-previews-carousel-qw')) {
                                this.resetJqueries();
                            }
                        }, 500);
                    })
                }

                setTimeout(() => {
                    this.setState({
                        show_spinner: false
                    })
                }, 800);
            })
            .catch(err => {
                setTimeout(() => {
                    this.setState({
                        show_spinner: false
                    })
                }, 800);
            })
    }

    closeModal(e, force = false) {
        if (force || (e && e.target && !e.target.closest("#prdGalleryModal"))) {
            this.setState({
                position: "unset",
                display: "none",
                show_spinner: true,
            }, () => {
                this.props.toggleQuickViewModal();
            })
        }
    }

    

    render() {

        if (this.state.redirect_to_login) {
            return <Redirect to={{
                pathname: '/login',
                state: { from: (`${window.location.pathname}${window.location.search}`) }
            }} />
        }

        let isInStock = this.state.product_quantity > 0;

        let slider_images_mapping = this.state.product_images.map((el, index) => {

            return <div data-value={el.attribute} data-image-path={`${el.path}`} key={`${el}${index}`} style={{ position: 'relative' }}>
                {!isInStock && (
                    <div className="out-of-stock-badge">
                        Sold Out
                    </div>
                )}
                {this.state.retail_price_discount > 0 && (
                    <div className="discount-badge" style={{ position: 'absolute', top: '10px', right: '10px', backgroundColor: '#ff3d00', color: '#fff', padding: '4px 8px', borderRadius: '4px', fontSize: '14px', fontWeight: 'bold', zIndex: 10 }}>
                        -{this.state.retail_price_discount}%
                    </div>
                )}
                <span className="prd-img" style={{
                    paddingBottom: "0px"
                }}>
                    <img
                        src={`${this.state.app_site_storage_path}${el.path}`}
                        className="lazyload fade-up elzoom js-prd-img"
                        alt=""
                    />
                </span>
            </div>

        })

        let bottom_slider_mapping = this.state.product_images.map((el, index) => {
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            return <a href="#" data-value={el.attribute} key={`${el}${index}`}>
                <span className="prd-img" style={{
                    paddingBottom: "0px"
                }}>
                    <img
                        src={`${this.state.app_site_storage_path}${el.path}`}
                        className="lazyload fade-up"
                        style={{
                        }}
                        alt='' />
                </span>
            </a>
        })

        // console.log('this.state.product_images', this.state.product_images)

        return (
            <div className="fancybox-container fancybox-is-open" id="fancybox-container-2"
                style={{
                    position: this.state.position,
                    transitionDuration: '366ms'
                }}
                onClick={this.closeModal}>
                <div className="fancybox-bg" />
                <div className="fancybox-inner">
                    <div className="fancybox-stage">
                        <div className="fancybox-slide fancybox-slide--html fancybox-slide--current fancybox-slide--complete" style={{}}>
                            <div className="fancybox-container fancybox-is-closed" id="fancybox-container-6" style={{ transitionDuration: '366ms' }}>
                                <div className="fancybox-bg" /><div className="fancybox-inner"><div className="fancybox-stage">
                                    <div className="fancybox-slide fancybox-slide--html fancybox-slide--current fancybox-slide--complete" style={{}}>


                                        <div className="modal--quickview modal-quickview--classic fancybox-content" id="modalQuickView"
                                            style={{
                                                display: this.state.display
                                            }}
                                        >
                                            <div className="modal-content" style={{ minWidth: '320px', minHeight: '450px' }}>
                                                {this.state.show_spinner ? (
                                                    <div className="d-flex align-items-center justify-content-center w-100" style={{ minHeight: '450px', padding: '30px' }}>
                                                        <Spinner type="product-detail" count={1} />
                                                    </div>
                                                ) : (
                                                    <div className="prd-block prd-block--prv-bottom" id="prdGalleryModal">
                                                    <div className="row no-gutters" style={{
                                                        // minHeight: "95vh",
                                                        overflowY: "scroll"
                                                    }}>
                                                        <div className="col-lg-9 quickview-gallery position-sticky">

                                                            <div className="aside-content p-4">
                                                                {/* Product Gallery */}
                                                                <div className="mb-2 js-prd-m-holder" />
                                                                <div className="prd-block_main-image">
                                                                    <div className="prd-block_main-image-holder" id="prdMainImage">
                                                                        <div className="product-main-carousel js-product-main-carousel-qw" id="slider_images_mapping" data-zoom-position="inner" ref={this.slider_ref}>
                                                                            {slider_images_mapping}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="product-previews-wrapper">
                                                                    <div className="product-previews-carousel js-product-previews-carousel-qw" id="bottom_slider_mapping">
                                                                        {bottom_slider_mapping}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            

                                                            {/* <div className="product-previews-wrapper d-none">
                                                                <div className="product-previews-carousel js-product-previews-carousel-qw" data-slick="{&quot;slidesToShow&quot;: 3, &quot;responsive&quot;: [{&quot;breakpoint&quot;: 992,&quot;settings&quot;: {&quot;slidesToShow&quot;: 3 }},{&quot;breakpoint&quot;: 480,&quot;settings&quot;: {&quot;slidesToShow&quot;: 3 }}]}">
                                                                    {slider_images_mapping}
                                                                </div>
                                                            </div> */}
                                                        </div>
                                                        <div className="col-lg-9 quickview-info custom " style={{
                                                            // height:"auto"
                                                        }}>
                                                            <div className="prd-block_info prd-block_info--style2" style={{
                                                            }}>
                                                                <div className="prd-block_title-wrap">
                                                                    <h1 className="prd-block_title">{this.state.name}</h1>
                                                                </div>
                                                                 <div className="prd-block_price">
                                                                    {this.state.hasDiscount ? (
                                                                        <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                                                            <span className="prd-block_price--old" style={{ textDecoration: 'line-through', color: '#999', fontSize: '1.2rem' }}>${roundToDecimal(this.state.retail_price)}</span>
                                                                            <span className="prd-block_price--actual" style={{ color: '#d9534f' }}>${roundToDecimal(this.state.price)}</span>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="prd-block_price--actual">${roundToDecimal(this.state.price)}</div>
                                                                    )}
                                                                    {/* <div className="prd-block_price-old-wrap"> */}
                                                                    {/* <span className="prd-block_price--old">$184</span> */}
                                                                    {/* <span className="prd-block_price--text">You Save: <span>$30</span> (<span>16</span>%)</span> */}
                                                                    {/* </div> */}
                                                                </div>
                                                                <div className="prd-block_description prd-block_info_item">

                                                                    <p id="" dangerouslySetInnerHTML={{ __html: this.state.short_description }}>
                                                                    </p>
                                                                    <div className="mt-1" />
                                                                    {/* <div className="row vert-margin-less">
                                                                        <div className="col-sm">
                                                                            <ul className="list-marker">
                                                                                <li>100% Polyester</li>
                                                                                <li>Lining:100% Viscose</li>
                                                                            </ul>
                                                                        </div>
                                                                        <div className="col-sm">
                                                                            <ul className="list-marker">
                                                                                <li>Do not dry clean</li>
                                                                                <li>Only non-chlorine</li>
                                                                            </ul>
                                                                        </div>
                                                                    </div> */}
                                                                </div>
                                                                <div className="prd-block_options mt-0">
                                                                    {/* <div className="prd-color swatches">
                                                                        <div className="option-label">Color:</div>
                                                                        <select className="form-control hidden single-option-selector-modalQuickView" id="SingleOptionSelector-2" data-index="option1">
                                                                            <option value="Beige" selected="selected">Beige</option>
                                                                            <option value="Black">Black</option>
                                                                            <option value="Red">Red</option>
                                                                        </select>
                                                                        <ul className="/images-list js-size-list" data-select-id="SingleOptionSelector-2">
                                                                            <li className="active">
                                                                                <a href="#" data-value="Beige" data-toggle="tooltip" data-placement="top" data-original-title="Beige"><span className="image-container image-container--product"><img src="/images/skins/fashion/product-page/product-01.jpg" alt=""/></span></a>
                                                                            </li><li>
                                                                            </li><li>
                                                                                <a href="#" data-value="Black" data-toggle="tooltip" data-placement="top" data-original-title="Black"><span className="image-container image-container--product"><img src="/images/skins/fashion/product-page/product-04.jpg" alt=""/></span></a>
                                                                            </li><li>
                                                                            </li><li>
                                                                                <a href="#" data-value="Red" data-toggle="tooltip" data-placement="top" data-original-title="Red"><span className="image-container image-container--product"><img src="/images/skins/fashion/product-page/product-07.jpg" alt=""/></span></a>
                                                                            </li>
                                                                        </ul>
                                                                    </div> */}
                                                                    <div className="prd-size swatches" style={{ display: 'none' }}>
                                                                        <div className="option-label">Size:</div>
                                                                        <select className="form-control hidden single-option-selector-modalQuickView" id="SingleOptionSelector-3" data-index="option2">
                                                                            <option value="Small" selected="selected">Small</option>
                                                                            <option value="Medium">Medium</option>
                                                                            <option value="Large">Large</option>
                                                                        </select>
                                                                        <ul className="size-list js-size-list" data-select-id="SingleOptionSelector-3">
                                                                            <li className="active"><a href="#" data-value="Small"><span className="value">Small</span></a></li>
                                                                            <li><a href="#" data-value="Medium"><span className="value">Medium</span></a></li>
                                                                            <li><a href="#" data-value="Large"><span className="value">Large</span></a></li>
                                                                        </ul>
                                                                    </div>
                                                                    <div className="prd-block_info-box prd-block_info_item" style={{ background: 'none', border: 'none', padding: 0 }}>
                                                                        <table style={{ border: 'none', margin: 0, padding: 0, width: '100%', maxWidth: '350px' }}>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td style={{ fontWeight: '500', padding: '3px 0', border: 'none', color: '#282828', width: '130px' }}>Product Type</td>
                                                                                    <td style={{ padding: '3px 0', border: 'none', color: '#777' }}>{this.state.category_name}</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style={{ fontWeight: '500', padding: '3px 0', border: 'none', color: '#282828' }}>SKU:</td>
                                                                                    <td style={{ padding: '3px 0', border: 'none', color: '#777' }}>{this.state.sku}</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style={{ fontWeight: '500', padding: '3px 0', border: 'none', color: '#282828' }}>Availability</td>
                                                                                    <td style={{ padding: '3px 0', border: 'none' }} className={isInStock ? "prd-in-stock" : "prd-out-of-stock"}>
                                                                                        {isInStock ? "In stock" : "Out of stock"}
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                    {this.state.color?.length > 0 && (
                                                                        <div className="prd-color swatches">
                                                                            <div className="option-label">Color:</div>
                                                                            <ul className="list-unstyled d-flex flex-wrap m-0" style={{ gap: '10px' }}>
                                                                                {this.state.color.map((item, index) => {
                                                                                    const isSelected = this.state.selectedColor && this.state.selectedColor.name === item.name;
                                                                                    return (
                                                                                    <li key={index} className="m-0 p-0" style={{ border: 'none' }}>
                                                                                        <a href="#" onClick={(e) => { e.preventDefault(); this.handleColorVariantSelection(e, item); }} data-toggle="tooltip" title={item.name} className="d-block" style={{ border: 'none' }}>
                                                                                            <span
                                                                                                className={`color-swatch-circle ${isSelected ? 'active' : ''}`}
                                                                                                style={{ backgroundColor: item.hex_value }}
                                                                                            />
                                                                                        </a>
                                                                                    </li>)
                                                                                })}
                                                                            </ul>
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                <div className="prd-block_actions prd-block_actions--wishlist">
                                                                    <div className="prd-block_qty">
                                                                        <div className="qty qty-changer">
                                                                            <button type="button" className="decrease"
                                                                                onClick={() => this.changeQuantity("subt")}
                                                                            />
                                                                            <input type="number" id="product-quantity" className="qty-input" name="quantity"
                                                                                // defaultValue={1}
                                                                                data-min={1}
                                                                                // data-max={1000}
                                                                                value={this.state.quantity}
                                                                            />
                                                                            <button type="button" className="increase"
                                                                                onClick={() => this.changeQuantity("add")}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="btn-wrap">
                                                                        {isInStock ? (
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn--add-to-cart js-trigger-addtocart js-prd-addtocart"
                                                                                data-product={`{"name": "${this.state.name ? this.state.name.replaceAll('"', " ").replaceAll(",", " ") : ""}", "path":"${this.state.app_site_storage_path}${this.state.image}", "url":"/products?id=${this.state.product_id}", "aspect_ratio":0.778}`}
                                                                                onClick={() => this.addToCart(this.state.product_data)}
                                                                            >
                                                                                Add to cart
                                                                            </button>
                                                                        ) : (
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn--add-to-cart"
                                                                                disabled
                                                                                style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed', color: '#a0a0a0', borderColor: '#e0e0e0' }}
                                                                            >
                                                                                UNAVAILABLE
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                    <div className="btn-wishlist-wrap heart--big pt-2 pl-1">
                                                                        {/* <a href="#" className="btn-add-to-wishlist ml-auto btn-add-to-wishlist--add js-add-wishlist" title="Add To Wishlist"><i className="icon-heart-stroke" /></a> */}
                                                                        {/* <a href="#" className="btn-add-to-wishlist ml-auto btn-add-to-wishlist--off js-remove-wishlist" title="Remove From Wishlist"><i className="icon-heart-hover" /></a> */}
                                                                        <WishListButton
                                                                            product_data={this.state.product_data}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                {/* <div className="prd-block_actions prd-block_actions--wishlist">
                                                                    <div className="prd-block_qty">
                                                                        <div className="qty qty-changer">
                                                                            <button className="decrease js-qty-button" />
                                                                            <input type="number" className="qty-input" name="quantity" defaultValue={1} data-min={1} data-max={1000} />
                                                                            <button className="increase js-qty-button" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="btn-wrap">
                                                                        <button className="btn btn--add-to-cart js-prd-addtocart" data-product="{&quot;name&quot;:&quot;Leather Pegged Pants &quot;, &quot;url&quot;: &quot;product.html&quot;, &quot;path&quot;: &quot;images/skins/fashion/products/product-01-1.jpg&quot;, &quot;aspect_ratio &quot;: &quot;0.78&quot;}">Add to cart</button>
                                                                    </div>
                                                                    <div className="btn-wishlist-wrap">
                                                                        <a href="#" className="btn-add-to-wishlist ml-auto btn-add-to-wishlist--add js-add-wishlist" title="Add To Wishlist"><i className="icon-heart-stroke" /></a>
                                                                        <a href="#" className="btn-add-to-wishlist ml-auto btn-add-to-wishlist--off js-remove-wishlist" title="Remove From Wishlist"><i className="icon-heart-hover" /></a>
                                                                    </div>
                                                                </div> */}
                                                                {/* <div className="prd-block_shopping-info-wrap-compact">
                                                                    <div className="prd-block_shopping-info-compact"><i className="icon-delivery-truck" /><span>Fast<br />Shipping</span></div>
                                                                    <div className="prd-block_shopping-info-compact"><i className="icon-return" /><span>Easy<br />Return</span></div>
                                                                    <div className="prd-block_shopping-info-compact"><i className="icon-call-center" /><span>24/7<br />Support</span></div>
                                                                </div> */}
                                                                <div className="prd-block_info_item mt-3 row row--sm-pad vert-margin-middle">
                                                                    <div className="col">
                                                                        <span className="btn btn--grey w-100"
                                                                            onClick={(e) => {
                                                                                this.props.history.push(`/product?id=${this.props.product_id}`)
                                                                                this.closeModal(e, true)
                                                                            }}>
                                                                            View Full Info
                                                                        </span>
                                                                        {/* <Link to={`/product?id=${this.props.product_id}`} className="btn btn--grey w-100"> */}
                                                                        {/* </Link> */}
                                                                    </div>
                                                                    <div
                                                                        className="col">
                                                                        <span
                                                                            className="btn btn--grey w-100"
                                                                            data-fancybox-close
                                                                            onClick={(e) => this.closeModal(e, true)}>
                                                                            Close
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="prd-block_info_item mt-0 row row--sm-pad vert-margin-middle"
                                                                    style={{
                                                                        visibility: "hidden"
                                                                    }}>
                                                                    <div className="col">
                                                                        <Link to={`/product?id=${this.props.product_id}`} className="btn btn--grey w-100">
                                                                            View Full Info
                                                                        </Link>
                                                                    </div>
                                                                    <div
                                                                        className="col">
                                                                        <span
                                                                            className="btn btn--grey w-100"
                                                                            data-fancybox-close
                                                                            onClick={(e) => this.closeModal(e, true)}>
                                                                            Close
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}




const mapStateToProps = state => ({
    cart_reducer: state.cart_reducer,
    wishlist_reducer: state.wishlist_reducer,
});


const mapDispatchToProps = () => {
    return {
        incrementCart, decrementCart, addToWishlist, removeFromWishlist,
    };
};


export default connect(
    mapStateToProps,
    mapDispatchToProps()
)(withRouter(QuickViewModal));

